/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";

export type MockupExamDTO = {
  id: string;
  score: string;
  status: string;
  num_tries: string;
  createdAt: string;
  quiz: {
    id: string;
    title: string;
  };
  quizId: string;
};

interface MockupExamsData {
  mockupExams: MockupExamDTO[];
  count: number;
  metaData: MetaData;
}

interface MockupExamsResponse {
  data?: MockupExamsData;
  error?: ApiError;
}

interface GetMockupExamsParams {
  page: number;
  limit: number;
}

export const getMyMockupExams = async ({
  page,
  limit,
}: GetMockupExamsParams): Promise<MockupExamsResponse> => {
  try {
    const response = await axios.get(`/certificate-exam/my-mockup-exams`, {
      params: { page, limit },
    });
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
